import { CheckRounded, KeyboardArrowDownRounded } from "@mui/icons-material";
import { Badge, Button, Menu, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useState } from "react";
import { MaterialSymbolIcon, MaterialSymbols } from "src/components";
import { useGetForms } from "src/http";

interface Props {
  selectedFormGuids: string[];
  onChange: (formGuids: string[]) => void;
}

const FormTypePicker = (props: Props) => {
  const { data, isLoading } = useGetForms();
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Badge color="primary" variant="dot" invisible={props.selectedFormGuids.length === 0}>
        <Button
          variant="tertiary"
          disabled={isLoading}
          startIcon={<MaterialSymbolIcon symbol={MaterialSymbols.ArticleShortcut} />}
          endIcon={<KeyboardArrowDownRounded />}
          onClick={(e) => setMenuAnchor(e.currentTarget)}
        >
          {props.selectedFormGuids.length > 0 && `${props.selectedFormGuids.length} `}Feedback Types
        </Button>
      </Badge>

      <Menu
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorEl={menuAnchor}
        slotProps={{
          paper: {
            sx: {
              minWidth: 225,
            },
          },
        }}
      >
        <ToggleButtonGroup
          value={props.selectedFormGuids}
          orientation="vertical"
          variant="menu"
          onChange={(_, formGuids: string[]) => props.onChange(formGuids)}
          sx={{ minWidth: "100%" }}
        >
          {[
            ...(data?.forms ?? [])
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((x, i) => (
                <ToggleButton key={i} value={x.guid}>
                  <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <Typography>{x.name}</Typography>
                    {props.selectedFormGuids.includes(x.guid) && <CheckRounded />}
                  </Stack>
                </ToggleButton>
              )),
          ]}
        </ToggleButtonGroup>
      </Menu>
    </>
  );
};

export { FormTypePicker };
